export const DOCUMENT_FIELDS_FEATURE_KEY = 'documentFields';
export const CONTACT_FIELDS_FEATURE_KEY = 'contactFields';